import type { OrderBookHeaderProps } from './types'

import Icon, { IconName } from '@/components/atomic/icon'

export const OrderBookHeader: React.FC<OrderBookHeaderProps> = ({
  isCollapsed = false,
  onToggleCollapse,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onToggleCollapse?.()
    }
  }

  return (
    <div className="w-full border-primary-border border-b-1 p-3 flex justify-between items-center">
      {onToggleCollapse && (
        // biome-ignore lint/a11y/useSemanticElements: Bulk suppression as part of biome migration
        <div
          className="cursor-pointer text-primary hover:text-primary-foreground transition-colors"
          onClick={onToggleCollapse}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label={isCollapsed ? 'Expand order book' : 'Collapse order book'}
        >
          {isCollapsed ? (
            <Icon iconName={IconName.ChevronUpIcon} size="large" />
          ) : (
            <Icon iconName={IconName.ChevronDownIcon} size="large" />
          )}
        </div>
      )}
    </div>
  )
}
